import { render } from "./ItemLinks.vue?vue&type=template&id=2df35dfc&scoped=true"
import script from "./ItemLinks.vue?vue&type=script&lang=js"
export * from "./ItemLinks.vue?vue&type=script&lang=js"

import "./ItemLinks.vue?vue&type=style&index=0&id=2df35dfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df35dfc"]])

export default __exports__